import { useField, useFormikContext } from 'formik';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Label } from '@/components/ui/label';
import { useRef, useState, useEffect } from 'react';

const FormikAsyncInfiniteSelect = ({
  name,
  label,
  placeholder,
  required,
  disabled,
  isMulti = false,
  loadOptions,
  defaultOption,
  onChange,
  classname = 'z-50 mb-4 ',
}: any) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [selectedOption, setSelectedOption] = useState<any>(isMulti ? [] : null);
  const initialAdditional = useRef({ page: 0 });

  const defaultApplied = useRef(false);

  useEffect(() => {
    if (!defaultApplied.current && defaultOption) {
      defaultApplied.current = true;

      if (isMulti) {
        setSelectedOption(defaultOption);
        setFieldValue(
          name,
          defaultOption.map((opt: any) => opt.value)
        );
      } else {
        setSelectedOption(defaultOption);
        setFieldValue(name, defaultOption.value);
      }
    }
  }, [defaultOption]);

  return (
    <div className={classname}>
      {label && (
        <Label>
          {label} {required && <span className="text-red-500">*</span>}
        </Label>
      )}

      <AsyncPaginate
        value={selectedOption}
        loadOptions={loadOptions}
        additional={initialAdditional.current}
        cacheUniqs={[field.value]}
        onChange={(option: any) => {
          setSelectedOption(option);

          if (isMulti) {
            setFieldValue(name, option ? option.map((o: any) => o.value) : []);
          } else {
            setFieldValue(name, option?.value ?? null);
            // setFieldValue('import_store_owner_id', option?.storeOwnerId ?? null);
            onChange?.(option);
          }
        }}
        isMulti={isMulti}
        placeholder={placeholder}
        isDisabled={disabled}
        debounceTimeout={350}
        isClearable
        className="theme-async-select"
        classNamePrefix="theme-async"
      />

      {meta.touched && meta.error && <p className="mt-1 text-sm text-red-500">{meta.error}</p>}
    </div>
  );
};

export default FormikAsyncInfiniteSelect;
